module.exports = __webpack_public_path__ + "22edc79bdb7438133fee87fab8eee59f.svg";